<template>
<div>


     <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>

<div v-if="type=='A'">


<h5 class="mt-4" style="color:black" > RICERCA ORDINI </h5>

<supplier-select @update="setSupplierId" v-bind:isActive="true"></supplier-select>
 <button  @click="getData()" type="button"  class="btn btn-primary mb-2">
    <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
   CERCA
       
    </button> 



<h4 style="color:navy" > <strong>LISTA ORDINI</strong> </h4>
<div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">

  <table class="table table-bordered table-hover _table-striped table-sm mb-0">
    <thead class="table-primary" >
      <tr>
        <th scope="col"></th>
        <th scope="col">#</th>

        <th scope="col">FORNITORE</th>
        <th scope="col">COLLEZIONE</th>
        <th>ANAGRAFICA PRODOTTO</th>  
        <th scope="col">SEDE</th>
        <th scope="col">NUMERO</th>
        <th scope="col">DATA</th>
       
        <th scope="col">REGISTRATO</th>
        <th scope="col">AGGIORNATO</th>
       
      </tr>
    </thead>
    <tbody>
      <tr data-toggle="tooltip" title="" class="pointer" v-on:dblclick="setOrder(item)" v-for="(item, index) in filteredOrders" :key="index">
        
        <td >
          <a class="ml-3" @click="editHeader(item)"><i style='color:brown' data-toggle="tooltip" title="Modifica intestazione"  :class="edit == true ? 'fa fa-edit':''" aria-hidden="true"></i></a>    
        </td>
        
        <td>{{index+1}}</td> 
        <td>{{item.supplier}}</td>
        
        <td>{{item.collection}}</td>
        <td>{{item.product_season}}</td>
        
        <td>{{item.store}}</td>
        <td>{{item.order_num}}</td>
        <td>{{item.order_date}}</td>
        
        <td >{{item.create_at}} </td>
        <td >{{item.update_at}} </td>
        
        
       
      </tr> 
    </tbody>
  </table>

</div>
<filter-key @update="setFilterKey"/>  



</div>
<div v-else>


    <edit-order-header @update="getData()" v-bind:_order="item" v-bind:type="'B'" ></edit-order-header>

    <button @click="type='A'" type="button"  class="btn btn-secondary mt-1 ml-2">
    <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
      RITORNA A LISTA ORDINI        
    </button> 

</div>  




</div>


</template>
<script>
import { mapGetters }    from 'vuex';


import supplierSelect    from '@/components/common/SupplierSelect.vue';
import editOrderHeader   from '@/components/order/OrderHeader.vue';
import api               from '@/api'
import filterKey         from '@/components/common/FilterKey.vue'

import modalMessage                from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm                from '@/components/modalDialog/ModalConfirm.vue'

export default {
  
  components  : {supplierSelect,filterKey,editOrderHeader,modalMessage,modalConfirm},

  props : ['edit'],
  data() {
    return {
        
      
        supplierId      : 0,
        items           : [],
        filterKey       : '',
        type            : 'A',
        item            : {}
      
    };
  },
  computed :{ 
    ...mapGetters(['company']),   
      filteredOrders : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  mounted: function() {},
  created: function() {

    //this.getData()
  },  
  methods: {


    editHeader(item)
    {

      if(this.edit)
      {
      
        this.item = item
        this.type = 'B'
      }
      
    },
    setFilterKey(value)
    {this.filterKey =  value
    },


    setSupplierId(supplierId)
    {
        this.supplierId = supplierId
    },

    setOrder(item)
    {  
     
      this.$emit('update',item)
      
    },
   
    async getData()
    {
        
        this.items   = []
              
        const sp       = 'spSupplierOrdersCollection'
        const payload  = {'supplierId' : this.supplierId,'companyId':this.company.Id,sp}
        
        this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})        
         try{

          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
          this.$refs.msgModal.close()  
          this.items = res.data.recordsets[0]
        
          if(this.items.length == 0)
          {
            this.$refs.msgModal.show('ORDINI FORNITORE INESISTENTI.',{title:'MESSAGGIO'},1)  
          }
                
        }catch(err)
        {
          this.$refs.msgModal.show(err)
        }
  

    },
      
  }
};
</script>
<style scoped>

.table {
  border-collapse: separate;
}


.my-custom-scrollbar {
  height: 500px;
  overflow-y: auto;
}

.table-wrapper-scroll-y {
  display: block;
}

/* tutti gli header */
.table thead th {
  position    : sticky;
  background  : #5c8fb1;
  color       : black;
  z-index     : 10;
}

/* prima riga */
.table thead tr:nth-child(1) th {
  top: 0;
  z-index: 20;
}

/* seconda riga */
.table thead tr:nth-child(2) th {
  top         : 50px;   /* altezza reale della prima riga */
  z-index     : 19;
  color       : rgb(16, 16, 15) !important;
  background  : #a9cbe2;
}



.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}

h4 {
  font-family   : 'Roboto Condensed';
  font-size     : 20px;
}


.table,
.table th, 
.table td
{
  border-color: #3b28a7 !important;
}
.table {
  border-collapse: separate;
}
</style>